<template>
  <div class="page">
    <box>
      <el-form label-position="right" label-width="90px" class="EL-Form">

                <el-col :lg="5" :xl="5">
          <el-form-item label="工厂编号" class="EL-Form-Item">


            <el-select

                collapse-tags
                v-model="mainSearch.fcCode"
                filterable
                clearable="clearable"
            >
              <el-option
                  v-for="item in factoryList"
                  :key="item.fcCode"
                  :value="item.fcCode"
                  :label="item.fcCode"
              >{{ item.fcCode }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :lg="5" :xl="5">
          <el-form-item label="入库单号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.irCode"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>


        <el-col :lg="5" :xl="5">
          <el-form-item label="库位编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.location"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input
              v-model="mainSearch.item"
              @change="saveSearch()"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
         <el-col :lg="4" :xl="4">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
            <el-button class="btn-t-delete" @click="reset">重置</el-button>
          </el-form-item>
        </el-col>


      </el-form>
    </box>
    <box fill>
      <plabel text="包材">
        <el-button
          v-authority="'BACK_MENU3_M27_B1'"
          :loading="xaloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="(add_or_edit = true), (editBoxShow = true)"
          >新增</el-button
        >

        <el-button v-authority="'BACK_MENU3_M27_B2'"  @click="importInShow=true" class="btn-t-edit">导入</el-button>
        <el-button v-authority="'BACK_MENU3_M27_B1'"  @click="insertOpenRecord" class="btn-t-edit">出入库记录</el-button>
        <el-button v-authority="'BACK_MENU3_M27_B1'"  @click="downLoadFile" class="btn-t-edit">导出Excel</el-button>

<!--
        <el-button
          v-authority="'BACK_MENU3_M22_B2'"
          :loading="downloadLoading"
          class="btn-t-edit"
          type="primary"
          @click="downLoadFile()"
          >导出EXCEL</el-button
        >-->
      </plabel>
      <h-table
        :headerCellStyle="mainData.headerCellStyle"
        style="flex: 1"
        @pageChange="getTableData"
        :data="mainData.data"
        pagination
        :nowPage.sync="mainData.nowPage"
        :pageSize.sync="mainData.pageSize"
        :total.sync="mainData.total"
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column
            label="工厂编号"
            align="center"
            prop="fcCode"
        ></el-table-column>
        <el-table-column
          label="入库单号"
          align="center"
          prop="receiptNo"
        ></el-table-column>


        <el-table-column
          label="库位编号"
          align="center"
          prop="lcCode"
        ></el-table-column>
        <el-table-column
          label="物料编号"
          align="center"
          prop="matCode"
        ></el-table-column>
        <el-table-column
            label="物料描述"
            align="center"
            prop="matName"
        ></el-table-column>

        <el-table-column
          label="数量"
          align="center"
          prop="matQuan"
        ></el-table-column>

        <el-table-column
            label="类型"
            align="center"
            prop="type"
        >
          <template slot-scope="scope">
              <span v-if="scope.row.type == '10'">入库</span>
              <span v-if="scope.row.type == '20'">出库</span>
          </template>

        </el-table-column>

        <el-table-column
            label="状态"
            align="center"
            prop="status"
        >
          <!--<template slot-scope="scope">
            <span v-if="scope.row.status == '10'">正常</span>
          </template>-->
        </el-table-column>

        <el-table-column label="入库时间" align="center" prop="matCreateTime"></el-table-column>
        <el-table-column
          label="出库时间"
          align="center"
          prop="outTime"
        ></el-table-column>
        <el-table-column
            label="备注"
            align="center"
            prop="remark"
        ></el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button v-authority="'BACK_MENU3_M27_B3'" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row))),
                  (mainObj.matQuan = mainObj.matQuan.replace('.00',''))
              " plain icon="el-icon-edit-outline" />
            <el-button v-authority="'BACK_MENU3_M27_B4'" type="danger" @click="deleteRow(scope.row)" size="mini" plain icon="el-icon-delete" />
          </template>
        </el-table-column>


      </h-table>
    </box>


    <el-dialog title="出入库记录" :visible.sync="mainSearcRecord.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
      <el-form label-position="right" label-width="80px" class="EL-Form">


        <el-col :lg="5" :xl="5">
          <el-form-item label="入库单号" class="EL-Form-Item">
            <el-input v-model="mainSearcRecord.query.irCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="工厂编号" class="EL-Form-Item">
            <el-select

                collapse-tags
                v-model="mainSearcRecord.query.fcCode"
                filterable
                clearable="clearable"
            >
              <el-option
                  v-for="item in factoryList"
                  :key="item.fcCode"
                  :value="item.fcCode"
                  :label="item.fcCode"
              >{{ item.fcCode }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="物料编号" class="EL-Form-Item">
            <el-input v-model="mainSearcRecord.query.matCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :xl="5">
          <el-form-item label="库位编号" class="EL-Form-Item">
            <el-input v-model="mainSearcRecord.query.lcCode" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>






        <el-col :lg="3" :xl="5">
          <el-form-item class="btn-edit-delete EL-Form-Item">
            <el-button class="btn-t-edit" @click="getOtherRecordList()">查询</el-button>
            <el-button class="btn-t-edit" @click="downLoadFile2">导出</el-button>
          </el-form-item>
        </el-col>
      </el-form>

      <h-table :headerCellStyle="mainSearcRecord.headerCellStyle" :style="$popups.harvestRecordStyle(0.60)" @pageChange="getOtherRecordList()" :data="mainSearcRecord.data" pagination :nowPage.sync="mainSearcRecord.pageNum" :pageSize.sync="mainSearcRecord.pageSize" :total.sync="mainSearcRecord.total">
        <el-table-column type="selection" align="center"> </el-table-column>

        <el-table-column label="工厂编号" align="center" prop="fcCode">
        </el-table-column>
        <el-table-column label="入库单号" align="center" prop="receiptNo">
        </el-table-column>
        <el-table-column label="库位编号" align="center" prop="lcCode">
        </el-table-column>

        <el-table-column label="物料编号" align="center" prop="matCode">
        </el-table-column>

        <el-table-column label="物料描述" align="center" prop="matName">
        </el-table-column>
        <el-table-column label="数量" align="center" prop="matQuan">
        </el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type == '10'">入库</span>
            <span v-if="scope.row.type == '20'">出库</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" prop="status">
        </el-table-column>
        <el-table-column label="入库时间" align="center" prop="matCreateTime"></el-table-column>
        <el-table-column
            label="出库时间"
            align="center"
            prop="outTime"
        ></el-table-column>
      </h-table>
      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button size="mini" @click="mainSearcRecord.insertShowRecord = false" type="info">关闭</el-button>
      </div>
    </el-dialog>





    <!-- 详情 -->

    <!-- 新增&&编辑框 -->
    <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <!-- <cascadeSearch ref="cascadeSearch" :f.sync="mainObj.fcCode" :w.sync="mainObj.shopCode" @change="queryMainData(),mainObj.sectionCode = ''" /> -->
                    <el-form-item  v-if="add_or_edit" label="单号" prop="receiptNo">
                        <el-input v-model="mainObj.receiptNo"> </el-input>
                    </el-form-item>
                    <el-form-item v-if="add_or_edit" label="工厂编号" prop="fcCode">
                        <el-select
                            collapse-tags
                            v-model="mainObj.fcCode"
                            filterable
                            clearable="clearable"
                        >
                        <el-option
                          v-for="item in factoryList"
                          :key="item.fcCode"
                          :value="item.fcCode"
                          :label="item.fcCode"
                          >{{ item.fcCode }}</el-option
                         >
                        </el-select>

                    </el-form-item>
                  <el-form-item v-if="add_or_edit" label="状态" prop="fcCode">
                       <el-select v-model="mainObj.status" clearable="clearable">
                          <el-option label="OK" value="OK"> </el-option>
                          <el-option label="HOLD" value="HOLD"> </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item  v-if="add_or_edit" label="库位编号" prop="lcCode">
                        <el-input v-model="mainObj.lcCode"> </el-input>
                    </el-form-item>
                    <el-form-item v-if="add_or_edit" label="物料编号" prop="matCode">
                        <el-input v-model="mainObj.matCode"> </el-input>
                    </el-form-item>
                    <el-form-item v-if="add_or_edit" label="物料描述" prop="matName">
                        <el-input v-model="mainObj.matName"> </el-input>
                    </el-form-item>
                    <el-form-item label="数量" prop="matQuan">
                        <el-input v-model="mainObj.matQuan" oninput="value=value.replace(/[^\d]/g,'')">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="add_or_edit" label="备注" prop="remark">
                        <el-input v-model="mainObj.remark"> </el-input>
                    </el-form-item>
                </el-form>
            </span>
      <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="close()">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
    </el-dialog>


    <el-dialog title="导入" :visible.sync="importInShow" class="fromDialog" :close-on-click-modal="false" :show-close="false" @click.stop :style="$popups.popups(0.8,0.9)">
      <div class="uploader-div" >
        <el-upload
            :action="action"
            :file-list="fileList"
            :limit="1"
            multiple
            :accept="accept"
            :before-upload="handleBeforeUpload"
            :on-error="handleUploadError"
            :on-exceed="handleExceed"
            :on-success="handleUploadSuccess"
            :on-change="handChange"
            :http-request="httpRequest"
            :show-file-list="true"
            :auto-upload="false"
            class="upload-file-uploader"
            ref="upload"
        >
          <!-- 上传按钮 -->
          <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" :disabled="fileList.length < 1" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer footer-bottom">
        <el-button @click="importInShow=false" type="info" class="btn-t-info">取 消</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "WhInventoryXaRecord",
  data() {
    return {
      warehouseList: [],
      mainData: {
        data: [],
        nowPage: 1,
        pageSize: 50,
        total: 0,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      mainSearcRecord: {
        query: {
          fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
          lrCode: "",
          matCode: "", //	物料编号
          lcCode: "", //
        },
        pageNum: 1,
        pageSize: 50,
        total: 0,
        data: [],
        insertShowRecord: false,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      accept: '',
      fileList: [],
      action: 'action',
      // 大小限制(MB)
      fileSize: 20,
      // 文件类型
      fileType:  ".xlsx",
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      },

      importData: {
        data: [],
        pageNum: 1,
        pageSize: 500000,
        total: 0,
        printTwo: false,
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },
      importInShow:false,
      mainObj: {},
      factoryList: [],
      // 筛选条件
      mainSearch: {
        irCode: "",
        site: "",
        whCode: "",
        location: "",
        item: "",
        batchLot: "",
        date: [],
        fcCode:localStorage.getItem("fcCode"),
      },
      //选中的工厂
      selectedFcList: [],
      rules: {
        receiptNo: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
        fcCode: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
        matCode: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
        matQuan: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
        lcCode: [{
          required: true,
          message: "请输入",
          trigger: "blur",
        }, ],
      },
      add_or_edit: Boolean, //新增|编辑
      //详情
      detailDialogShow: false,
      editBoxShow: false, //编辑框
      dataDetails: {
        data: {},
        xaList: [],
        whList: [],
        headerCellStyle: () => {
          return "background-color: #1f6cec";
        },
      },

      downloadLoading: false, //下载中

      logContent: "", //操作日志-内容
      logRemarks: "", //操作日志-备注
      // 输入框延时加载
      isSetTimeout: null,

      //同步XA
      xaloadLoading: false, //同步中

      irId: '',
    };
  },
  watch: {
    selectedFcList: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
    mainSearch: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
    chooseDictDataList: {
      handler(newVal) {
        clearTimeout(this.isSetTimeout);
        this.isSetTimeout = setTimeout(() => {
          this.getTableData(newVal);
        }, 1000);
      },
      deep: true,
    },
  },
  computed: {
    pickerOptions() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[0]) {
            return time.getTime() < new Date(_this.mainSearch.date[0]);
          }
        },
      };
    },
    pickerOptions0() {
      let _this = this;
      return {
        disabledDate(time) {
          if (_this.mainSearch.date[1]) {
            return time.getTime() > new Date(_this.mainSearch.date[1]);
          }
        },
      };
    },
  },

  activated() {
    /* 获取首页的数据 */
    this.getTableData();
    this.getFactory();
  },
  methods: {

    getOtherRecordList(){
      this.$http
          .request({
            url: "/api/packagingMaterial/getPackagingMaterialDetail",
            method: "GET",
            params: {
              pageNum: this.mainSearcRecord.nowPage, //	页号
              pageSize: this.mainSearcRecord.pageSize, //	页大小
              irCode: this.mainSearcRecord.query.irCode || null,
              //site: this.mainSearch.site || null,
              fcCode: this.mainSearcRecord.query.fcCode || null,
              location: this.mainSearcRecord.query.lcCode || null,
              matCode: this.mainSearcRecord.query.matCode || null,
            },
          })
          .then((res) => {
            if (res.status == 100) {
              this.mainSearcRecord.data = res.data.list;
              this.mainSearcRecord.total = res.data.total;
            } else {
              this.$message.error("错误");
            }
          });
    },
    insertOpenRecord() {
      this.mainSearcRecord.insertShowRecord = true;
      this.getOtherRecordList();
    },
    httpRequest(param) {

      var formData = new FormData();
      formData.append("file", param.file);
      this.$http
          .request({
            url: "/api/packagingMaterial/importExcel",
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            showLoading: true,
            data: formData,
          })
          .then((res) => {
            if (res.status === 100) {
              this.importData.data = res.data.list || [];
              this.$notify({
                message: "上传成功!",
                type: "success",
              });
            } else {
              this.$notify({
                message: res.message,
                type: "danger",
              });
            }
          });

    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf("."));
        }
        const isTypeOk =  this.fileType.indexOf(fileExtension) != -1 ? true:false;

        if (!isTypeOk) {
          this.$message.error(`文件格式不正确, 请上传${this.fileType}格式文件!`);
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },
    /** 手动提交上传 */
    submitUpload() {
      if (this.fileList.length <= 0) {
        return false
      }
      this.$refs.upload.submit()
    },
    /** 文件状态改变时调用 */
    handChange(file, fileList) {
      this.fileList = fileList
    },
    // 删除文件
    handleDelete(index) {
      this.fileList.splice(index, 1);
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`只允许上传1个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");

    },

    // 上传成功回调

    handleUploadSuccess(res, file) {
      this.$message.success("上传成功");
      this.getTableData();
      this.cancel()

    },
    close() {
      this.editBoxShow = false;
      this.mainObj = {}
    },
    open() {
      if (this.add_or_edit) {
        //新增
        this.mainObj = JSON.parse(
            JSON.stringify({
              pmId: null,
              receiptNo: "",
              fcCode: "",
              lcCode: "",
              matCode: "",
              matQuan: "",
              remark: "",
              matName: "",
            })
        );
      } else {
        this.getTableData();

      }
    },
    getFactory() {
      this.selectedFcList[0] = localStorage.getItem("fcCode");

      let fcCodes = null;
      let userFcCode = localStorage.getItem("fcCode") || null;

      if (userFcCode == "YL" || userFcCode == "SY") {
        fcCodes = userFcCode;
      }

      this.$http
          .request({
            url: "/api/factory/getFactoryAll",
            method: "GET",
            params: {
              fcCode: fcCodes,
            },
          })
          .then((res) => {
            if (res.status == 100) {
              this.factoryList = res.data.list || [];
            } else {
              this.$message.error("错误");
            }
          });
    },
    //新增
    add() {
      if (this.submitForm("mainObj")) {
        this.$http
            .request({
              url: "/api/packagingMaterial/insertPackagingMaterial",
              method: "POST",
              showLoading: true,
              data: this.mainObj,
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "新增成功！",
                  type: "success",
                });

              } else {
                this.$notify.error({
                  title: "失败",
                  message: resp.message,
                });

              }

              this.systemLog();
              this.editBoxShow = false;
              this.getTableData();
            })
            .catch((error) => {
              this.$notify.error({
                title: "失败",
                message: "调用失败",
              });
            });
      }
    },
    submitForm(formName) {
      let r = Boolean;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          r = true;
        } else {
          r = false;
        }
      });
      return r;
    },
    //编辑
    deleteRow(obj) {
        obj.type="20";
        this.$http
            .request({
              url: "/api/packagingMaterial/updatePackagingMaterial",
              method: "PUT",
              showLoading: true,
              data: obj,
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "修改成功！",
                  type: "success",
                });
              } else {
                this.$notify.error({
                  title: "失败",
                  message: resp.message,
                });
              }

              this.editBoxShow = false;
              this.getTableData();
            })
            .catch((error) => {
              this.$notify.error({
                title: "失败",
                message: "调用失败",
              });
            });

    },
    editRow() {
      if (this.submitForm("mainObj")) {
        this.$http
            .request({
              url: "/api/packagingMaterial/updatePackagingMaterial",
              method: "PUT",
              showLoading: true,
              data: this.mainObj,
            })
            .then((resp) => {
              if (resp.status == 100) {
                this.$notify({
                  title: "成功",
                  message: "修改成功！",
                  type: "success",
                });
              } else {
                this.$notify.error({
                  title: "失败",
                  message: resp.message,
                });
              }

              this.editBoxShow = false;
              this.getTableData();
            })
            .catch((error) => {
              this.$notify.error({
                title: "失败",
                message: "调用失败",
              });
            });
      }
    },
    // 节流搜索
    saveSearch() {
      if (window.lazy) window.clearTimeout(window.lazy);
      window.lazy = window.setTimeout(() => {
        this.getTableData();
      }, 1000);
    },
    /**
     * 重置
     */
    reset() {
      this.mainSearch = {
        irCode: "",
        fcCode: "",
        whCode: "",
        location: "",
        item: "",
        date: [],
      };
    },
    /**
     * 获取列表
     */
    getTableData() {
      this.$http
        .request({
          url: "/api/packagingMaterial/getPackagingMaterial",
          method: "GET",
          params: {
            pageNum: this.mainData.nowPage, //	页号
            pageSize: this.mainData.pageSize, //	页大小
            irCode: this.mainSearch.irCode || null,
            //site: this.mainSearch.site || null,
            fcCode: this.mainSearch.fcCode || null,
            location: this.mainSearch.location || null,
            item: this.mainSearch.item || null,
            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.mainData.data = res.data.list;
            this.mainData.total = res.data.total;
          } else {
            this.$message.error("错误");
          }
        });
    },
    /**
     * 详情
     */
    detailDialog(row) {
      this.detailDialogShow = true;
      this.dataDetails.data = row;
      this.getWhXaDetails(row.irId);
    },
    detailDialogClose() {
      this.detailDialogShow = false;
      this.dataDetails.data = {};
      this.dataDetails.xaList = [];
      this.dataDetails.whList = [];
    },
    getWhXaDetails(irId) {
      this.irId = irId;
      this.$http
        .request({
          url: "/api/whXaRecord/getWhXaDetails",
          method: "GET",
          params: {
            irId: irId,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.dataDetails.xaList = res.data.xaList || [];
            this.dataDetails.whList = res.data.whList || [];
          } else {
            this.$message.error("错误");
          }
        });
    },
    updatePackagingMaterial() {
      if (this.dataDetails.whList.length > 0) {
        this.$http
          .request({
            url: "/api/packagingMaterial/updatePackagingMaterial",
            method: "POST",
            data: this.dataDetails.whList,
          })
          .then((res) => {
            if (res.status == 100) {
              this.detailDialogClose();
            } else {
              this.$message.error("错误");
            }
          });
      } else {
        this.detailDialogClose();
      }
    },
    updateStatus(data) {

      if(data.dealReason == undefined){

        data.dealReason = '';

      }

      this.$http
        .request({
          url: "/api/whXaRecord/updateStatus",
          method: "PUT",
          params: {
            irId: data.irId,
            reason: data.dealReason,
          },
        })
        .then((res) => {
          if (res.status == 100) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          } else {
            this.$message.error("错误");
          }
        });
    },
    insertXaWhInventory(data){
      this.$http
        .request({
          url: "/api/whXaRecord/insertXaWh",
          method: "POST",
          data: data,
          params: {
            irId: this.irId
          }
        })
        .then((res) => {
          if (res.status == 100) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.getWhXaDetails(this.irId);
          } else {
            this.$message.error("错误");
          }
        });

    },

    /**
     * 同步XA
     *  1. 网页端提交同步信息，2.开始同步库存。 3. 等同步完成后进行对比， 4. 对比结果网页中查看， 5. 对比的数据进行处理。
     */
    synXaInventory() {
      console.log("1111");
      this.xaloadLoading = true;
      this.$http
        .request({
          url: "/api/whXaRecord/synXaInventory",
          method: "GET",
          params: {},
        })
        .then((resp) => {

          if(resp.status == 100){
            this.$message({
              message: resp.message,
              type: "success",
            });
          }else{
            this.$message({
              message: resp.message,
              type: "error",
            });
          }
          this.xaloadLoading = false;
        })
        .catch((error) => {
          this.xaloadLoading = false;
        });
      console.log("2222");
      this.xaloadLoading = false;
    },

    //表格导出
    downLoadFile() {
      this.downloadLoading = true;
      var paramsObj = {
        irCode: this.mainSearch.irCode || null,
        //site: this.mainSearch.site || null,
        fcCode: this.mainSearch.fcCode || null,
        location: this.mainSearch.location || null,
        item: this.mainSearch.item || null,
        beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
        endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
        .request({
          url: "/api/packagingMaterial/getPackagingMaterial",
          method: "GET",
          params: paramsObj,
        })
        .then((resp) => {
          resp.status == 100
            ? this.downLoad(resp.data.list || [])
            : this.$notify.error({
                message: "查询失败",
              });
        });
    },

    //表格导出
    downLoadFile2() {
      this.downloadLoading = true;
      var paramsObj = {
        irCode: this.mainSearcRecord.query.irCode || null,
        //site: this.mainSearch.site || null,
        fcCode: this.mainSearcRecord.query.fcCode || null,
        location: this.mainSearcRecord.query.lcCode || null,
        matCode: this.mainSearcRecord.query.matCode || null,
        pageNum: 1,
        pageSize: 999999,
      };

      this.$http
          .request({
            url: "/api/packagingMaterial/getPackagingMaterialDetail",
            method: "GET",
            params: paramsObj,
          })
          .then((resp) => {
            resp.status == 100
                ? this.downLoad2(resp.data.list || [])
                : this.$notify.error({
                  message: "查询失败",
                });
          });
    },
    downLoad2(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function (c) {
          if (c.type == '10') {
            c["type"] = "入库";
          } else if(c.type == '20'){
            c["type"] = "出库";
          }
        });
        const tHeader = [
          "工厂编号",
          "入库单号",
          "库位编号",
          "物料编号",
          "物料描述",
          "数量",
          "类型",
          "状态",
          "入库时间",
          "出库时间",
          "备注",
        ];
        const filterVal = [
          "fcCode",
          "receiptNo",
          "lcCode",
          "matCode",
          "matName",
          "matQuan",
          "type",
          "status",
          "matCreateTime",
          "outTime",
          "remark",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "其他项管理记录",
        });
        this.logContent = "导出";
        this.logRemarks = "wh_inventory：其他项管理记录";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    downLoad(list) {
      import("@/libs/Export2Excel").then((excel) => {
        list.forEach(function (c) {
          if (c.type == '10') {
            c["type"] = "入库";
          } else if(c.type == '20'){
            c["type"] = "出库";
          }
        });
        const tHeader = [
          "工厂编号",
          "入库单号",
          "库位编号",
          "物料编号",
          "物料描述",
          "数量",
          "类型",
          "状态",
          "入库时间",
          "出库时间",
          "备注",
        ];
        const filterVal = [
          "fcCode",
          "receiptNo",
          "lcCode",
          "matCode",
          "matName",
          "matQuan",
          "type",
          "status",
          "matCreateTime",
          "outTime",
          "remark",
        ];
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "其他项管理",
        });
        this.logContent = "导出";
        this.logRemarks = "wh_inventory：其他项管理";
        this.systemLog();
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    /**
     * 操作日志
     */
    systemLog() {
      let objData = {
        logType: "库存记录",
        logContent: this.logRemarks || "",
        //logRemarks: this.logRemarks || "",
        logUser: localStorage.getItem("user") || "",
      };
      this.$http
        .request({
          url: "api/log/insert",
          method: "POST",
          showLoading: true,
          data: objData,
        })
        .then((resp) => {
          this.logContent = "";
          this.logRemarks = "";
          if (resp.status == 100) {
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style scoped>
.div {
  width: 95%;
  height: 100%;
  margin-left: 30px;
  margin-bottom: 100px;
  text-align: center;
}

.div table th {
  width: 100px;
  height: 30px;
  border: 1px solid black;
  background: rgb(201, 197, 197);
  color: rgb(14, 13, 13);
}

.div table td {
  width: 100px;
  height: 30px;
  /* border: 1px solid black; */
  color: rgb(14, 13, 13);
}

.div1 {
  width: 300px;
  height: 40px;
  /* border: 1px solid black; */
  text-align: left;
  color: rgb(14, 13, 13);
  font-weight: bold;
  margin-left: 50px;
}
</style>